import React from 'react';

const TFJS_Tutorial = () => {
    return (
        <div>TFJS_Tutorial Component</div>
    );
}

export default TFJS_Tutorial;
